import React, { useState, Component, useRef, useEffect } from "react";
import useStyles from "./styles";
import { useLocation, useHistory, Link } from "react-router-dom";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import { withStyles } from "@material-ui/core/styles";
import { Redirect } from "react-router-dom";
import { Divider, Icon, Button } from "@material-ui/core";
import ListSubheader from "@material-ui/core/ListSubheader";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
import Slider from "@material-ui/core/Slider";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import NativeSelect from "@material-ui/core/NativeSelect";
import InputBase from "@material-ui/core/InputBase";
import api from "../../Axios/api";
import Modal from "@material-ui/core/Modal";

//Icons
import ExpandLess from "@material-ui/icons/ArrowDropDown";
import ExpandMore from "@material-ui/icons/ArrowRight";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";

//files
import noImage from "../../assets/images/Product Images/noImage.png";
import loadingImg from "../../assets/images/loadingImg.gif";

// MUI Components
import { Grid, Typography } from "@material-ui/core";
import ProductCard from "../../Components/Product-Card/ProductCard";
import { Close, Filter, Tune } from "@material-ui/icons";

export default function Products() {
  const BootstrapInput = withStyles((theme) => ({
    root: {
      "label + &": {
        marginTop: theme.spacing(3),
      },
    },
    input: {
      borderRadius: 4,
      position: "relative",
      backgroundColor: theme.palette.background.paper,
      border: "1px solid #ced4da",
      fontSize: 16,
      padding: "10px 26px 10px 12px",
      transition: theme.transitions.create(["border-color", "box-shadow"]),
      // Use the system font instead of the default Roboto font.
      fontFamily: [
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(","),
      "&:focus": {
        borderRadius: 4,
        borderColor: "#80bdff",
        boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
      },
    },
  }))(InputBase);

  const classes = useStyles();
  const [maxPrice, setMaxPrice] = useState(0);
  const [minPrice, setMinPrice] = useState(0);
  const [filterError, setFilterError] = useState(null);
  const history = useHistory();
  const [isListOpen, setisListOpen] = React.useState({});
  const [priceRange, setPriceRange] = React.useState([minPrice, maxPrice]);
  const [filters, setFilters] = useState(null);
  const [onSale, setOnSale] = React.useState({
    checkedA: true,
    checkedB: false,
  });
  const [selectedFirstDate, setFirstSelectedDate] = React.useState("");
  const [selectedSecondDate, setSecondSelectedDate] = React.useState("");
  //Query params
  const search = useLocation().search;
  const mainCategoryName = new URLSearchParams(search).get("mainCategoryName");
  const subCategoryName = new URLSearchParams(search).get("subCategoryName");
  const mainCategoryOfSubCategory = new URLSearchParams(search).get(
    "mainCategoryOfSubCategory"
  );
  const searchQuery = new URLSearchParams(search).get("searchQuery");
  const allProductsFilter = new URLSearchParams(search).get("productsFilter");
  const [sort, setSort] = React.useState([
    "Best Matched",
    "Best Selling",
    "High Rated",
    "New Arrivals",
    "Price (Low to High)",
    "Price (High to Low)",
  ]);
  const [selectedSort, setSelectedSort] = useState(sort[0]);
  const [categories, setCategories] = React.useState([]);
  const [subCategoriesOfMainCategory, setSubCategoriesOfMainCategory] =
    useState([]);
  const [brands, setBrands] = React.useState([]);
  const [productsData, setProductsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [openFiltersModal, setOpenFiltersModal] = React.useState(false);

  const handleOpenFiltersModal = () => {
    setOpenFiltersModal(true);
  };

  const handleCloseFiltersModal = () => {
    setOpenFiltersModal(false);
  };

  //getting data from API
  useEffect(() => {
    //scroll to the top of page
    window.scrollTo(0, 0);
    setIsLoading(true);
    setProductsData([]);
    //getting all prducts of selected category
    if (!searchQuery) {
      getAllProductsOfSelectedCategory();
    } else {
      getSearchedQueryProducts();
    }

    //for unchecking all filters setted before
    unCheckAllFilters();

    //for getting all categories data
    api
      .get(`/buyer/product/categories/all`, {}, { Headers: {} })
      .then((res) => {
        setCategories(res.data.data.categories);
      })
      .catch((error) =>
        console.log("error in getting data of homepage", error)
      );

    //for getting brands/vendors of selected products category
    api
      .get(
        mainCategoryName
          ? mainCategoryName === "All Categories"
            ? `/buyer/vendors/all`
            : `/buyer/vendors/mainCategory/${mainCategoryName}`
          : `/buyer/vendors/subCategory/${subCategoryName}`,
        {},
        { Headers: {} }
      )
      .then((res) => {
        res.data.data.vendors.push({
          _id: "Other",
          vendorName: "Other",
          vendorCategory: "Other",
        });
        // console.log(res.data.data.vendors);
        setBrands(res.data.data.vendors);
      })
      .catch((error) =>
        console.log("error in getting data of homepage", error)
      );

    //for getting subCategories of selected mainCategory Data for filters
    api
      .get(
        mainCategoryName === "All Categories"
          ? `/buyer/product/subCategoriesNames/all`
          : `/buyer/product/subCategoriesNames/mainCategory/${
              mainCategoryName ? mainCategoryName : mainCategoryOfSubCategory
            }`,
        {},
        { Headers: {} }
      )
      .then((res) => {
        setSubCategoriesOfMainCategory(res.data.data.subCategories);
      })
      .catch((error) =>
        console.log("error in getting data of all categories", error)
      );
  }, [mainCategoryName, subCategoryName, searchQuery]);

  //get all products of selected category
  const getAllProductsOfSelectedCategory = () => {
    api
      .get(
        mainCategoryName
          ? mainCategoryName === "All Categories"
            ? `/buyer/products`
            : `/buyer/products/category/${mainCategoryName}`
          : `/buyer/products/subcategory/${subCategoryName}`,
        {},
        { Headers: {} }
      )
      .then((res) => {
        // console.log("products data", res.data.data.products);
        setProductsAccordingToData(res.data.data);
        setIsLoading(false);
      })
      .catch((error) => console.log("error in getting data of API: ", error));

    //for getting deals products
    if (allProductsFilter === "onSale") {
      api
        .post(`/buyer/products/filter`, { isOnSale: true }, { Headers: {} })
        .then((res) => {
          setProductsAccordingToData(res.data.data);
        })
        .catch((error) =>
          console.log("error in getting data of search", error)
        );
    }
  };

  const setProductsAccordingToData = (data) => {
    let min, max;
    setProductsData(data.products);

    // for setting price ranges in filters box
    if (data.maxPrice.length > 0) {
      data.maxPrice[0].discountPrice
        ? (max = data.maxPrice[0].discountPrice)
        : (max = data.maxPrice[0].salePrice);
      if (max) setMaxPrice(max);
    }

    if (data.minPrice.length > 0) {
      data.minPrice[0].discountPrice
        ? (min = data.minPrice[0].discountPrice)
        : (min = data.minPrice[0].salePrice);
      if (min) setMinPrice(min);
    }
    if (data.minPrice.length > 0 && data.maxPrice.length > 0) {
      setPriceRange([min, max]);
    } else {
      setPriceRange([null, null]);
      setMinPrice(null);
      setMaxPrice(null);
    }
  };

  const getSearchedQueryProducts = () => {
    const filters = {
      mainCategoryName: mainCategoryName,
      name: searchQuery,
    };
    if (mainCategoryName === "All Categories") {
      delete filters.mainCategoryName;
    }
    //getting all products according to search filters applied
    api
      .post(`/buyer/products/filter`, filters, { Headers: {} })
      .then((res) => {
        // console.log("filters", filters, " products", res.data.data);
        setProductsAccordingToData(res.data.data);
        setIsLoading(false);
      })
      .catch((error) => console.log("error in getting data of search", error));
  };

  //For opening products of selected sub-category page
  const openProductsOfSubCategory = (category, mainCategoryName) => {
    history.push(
      `/products?subCategoryName=${encodeURIComponent(
        category.name
      )}&mainCategoryOfSubCategory=${encodeURIComponent(mainCategoryName)}`
    );
  };

  const handleClickListOpen = (id) => {
    setisListOpen((prevState) => ({ ...prevState, [id]: !prevState[id] }));
  };

  //For slider of price
  function valuetext(num) {
    return num;
  }
  function numFormatter(num) {
    if (num > 999 && num < 1000000) {
      return (num / 1000).toFixed(1) + "K"; // convert to K for number from > 1000 < 1 million
    } else if (num > 1000000) {
      return (num / 1000000).toFixed(1) + "M"; // convert to M for number from > 1 million
    } else if (num < 900) {
      return num; // if value < 1000, nothing to do
    }
  }

  const handleChangePriceRange = (event, newValue) => {
    setPriceRange(newValue);
  };

  const handleChangeOnSale = (event) => {
    setOnSale({ ...onSale, [event.target.name]: event.target.checked });
  };

  const handleFirstDateChange = (date) => {
    setFirstSelectedDate(date.target.value);
  };

  const handleSecondDateChange = (date) => {
    setSecondSelectedDate(date.target.value);
  };

  function UnSelectAll(name) {
    var items = document.getElementsByName(name);
    for (var i = 0; i < items.length; i++) {
      if (items[i].type == "checkbox") items[i].checked = false;
    }
  }
  const removeAllFilters = () => {
    handleCloseFiltersModal()
    unCheckAllFilters();
    getAllProductsOfSelectedCategory();
  };

  const unCheckAllFilters = () => {
    setOnSale({ checkedA: true, checkedB: false });
    setPriceRange([minPrice, maxPrice]);
    setFirstSelectedDate(null);
    setSecondSelectedDate(null);
    UnSelectAll("brandCheckBox");
    UnSelectAll("categoryCheckBox");
    document.getElementById("startDate").value = null;
    document.getElementById("endDate").value = null;
  };

  const handleChangeSorting = (event) => {
    const sortingMethod = event.target.value;
    const tempFilters = {};
    setSelectedSort(sortingMethod);
    if (!filters && allProductsFilter === "onSale") {
      tempFilters.isOnSale = true;
    }

    //if filters are empty then we add selected products category or subcategory in them
    if (!filters) {
      if (subCategoryName) {
        tempFilters.subCategories = [subCategoryName];
      }
      if (mainCategoryName && mainCategoryName != "All Categories") {
        tempFilters.mainCategoryName = mainCategoryName;
      }
    }
    if (sortingMethod === "Best Matched" || sortingMethod === "High Rated") {
      setIsLoading(true);
      setProductsData([]);
      //getting all products according to filters and sorting method applied
      api
        .post(`/buyer/products/filter`, !filters ? tempFilters : filters, {
          Headers: {},
        })
        .then((res) => {
          setIsLoading(false);
          setProductsData(res.data.data.products);
        })
        .catch((error) =>
          console.log("error in getting data of sorting products.", error)
        );
    }

    if (sortingMethod === "Best Selling") {
      setIsLoading(true);
      setProductsData([]);
      //getting all products according to filters and sorting best selling method applied
      api
        .post(
          `/buyer/products/sort/topSelling`,
          !filters ? tempFilters : filters,
          {
            Headers: {},
          }
        )
        .then((res) => {
          setIsLoading(false);
          setProductsData(res.data.data.products);
        })
        .catch((error) =>
          console.log("error in getting data of sorting products..", error)
        );
    }

    if (sortingMethod === "Price (Low to High)") {
      productsData.sort((a, b) => a.salePrice - b.salePrice);
      setProductsData(productsData);
    }

    if (sortingMethod === "Price (High to Low)") {
      productsData.sort((a, b) => b.salePrice - a.salePrice);
      setProductsData(productsData);
    }

    if (sortingMethod === "New Arrivals") {
      productsData.sort((a, b) => {
        var dateA = new Date(a.createdAt),
          dateB = new Date(b.createdAt);
        return dateB - dateA;
      });
      setProductsData(productsData);
    }
    // console.log("filters", filters, "tempFilters", tempFilters);
  };

  const handleApplyFilters = () => {
    let vendors = [];
    let subCategories = [];
    setFilterError(null);
    document.getElementById("endDate").style.border = "none";
    document.getElementById("startDate").style.border = "none";

    var vendorsBoxes = document.getElementsByName("brandCheckBox");
    for (var i = 0; i < vendorsBoxes.length; i++) {
      if (vendorsBoxes[i].checked) {
        vendors.push(vendorsBoxes[i].value);
      }
    }
    var subCategoryBoxes = document.getElementsByName("categoryCheckBox");
    for (var j = 0; j < subCategoryBoxes.length; j++) {
      if (subCategoryBoxes[j].checked) {
        subCategories.push(subCategoryBoxes[j].value);
      }
    }

    const filters = {
      isOnSale: onSale.checkedB,
      minPrice: priceRange[0],
      maxPrice: priceRange[1],
      startDate: selectedFirstDate,
      endDate: selectedSecondDate,
      vendors,
      subCategories,
    };
    setFilters(filters);
    //now i will delete attributes in filters obj that do not have any value
    if (!onSale.checkedB) {
      delete filters.isOnSale;
    }
    if (allProductsFilter === "onSale") {
      filters.isOnSale = true;
    }
    if (!minPrice && !maxPrice) {
      delete filters.minPrice;
      delete filters.maxPrice;
    }
    if (filters.minPrice === minPrice && filters.maxPrice === maxPrice) {
      delete filters.minPrice;
      delete filters.maxPrice;
    }
    if (!selectedFirstDate && !selectedSecondDate) {
      delete filters.startDate;
      delete filters.endDate;
    }
    if (selectedFirstDate && !selectedSecondDate) {
      document.getElementById("endDate").style.border = "0.3px solid red";
      setFilterError("Please select end date !");
      return;
    }
    if (!selectedFirstDate && selectedSecondDate) {
      document.getElementById("startDate").style.border = "0.3px solid red";
      setFilterError("Please select start date !");
      return;
    }
    if (selectedSecondDate && selectedFirstDate) {
      if (selectedFirstDate > selectedSecondDate) {
        document.getElementById("startDate").style.border = "0.3px solid red";
        setFilterError("Incorrect value! Start Date is greater than end date.");
        return;
      }
      if (selectedSecondDate < selectedSecondDate) {
        document.getElementById("endDate").style.border = "0.3px solid red";
        setFilterError("Incorrect value! End Date is lesser than start date !");
        return;
      }
    }
    handleCloseFiltersModal()
    if (vendors.length === 0) {
      delete filters.vendors;
    }
    if (subCategories.length === 0) {
      delete filters.subCategories;
    }
    //if obj is null then return
    if (Object.keys(filters).length === 0) {
      return;
    }
    setIsLoading(true);
    setProductsData([]);
    //we always push the selected category or subCategory with filters, so we get results of only that category
    if (subCategoryName) {
      if (!filters.subCategories) {
        filters.subCategories = [subCategoryName];
      } else {
        filters.subCategories.push(subCategoryName);
      }
    }
    if (mainCategoryName && mainCategoryName != "All Categories") {
      filters.mainCategoryName = mainCategoryName;
    }

    console.log("filters", filters);

    //getting all products according to filters applied
    api
      .post(`/buyer/products/filter`, filters, { Headers: {} })
      .then((res) => {
        setIsLoading(false);
        setProductsData(res.data.data.products);
      })
      .catch((error) =>
        console.log("error in getting data of homepage", error)
      );
  };

  const filtersBox = () => {
    return (
      <div className={classes.filtersMainBox}>
        <div className={classes.categoriesFilterHeading}>
          <Typography variant="h5" style={{ padding: 13 }}>
            Filters
          </Typography>
        </div>
        <div className={classes.priceCateBrandMainDiv}>
          {/* Price Box */}
          <div className={classes.priceFilterBox}>
            <Typography variant="h5">Price</Typography>
            <div className={classes.slider}>
              <Typography variant="p" style={{ color: "#666" }}>
                Rs. {priceRange[0]}
              </Typography>
              <Typography variant="p" style={{ color: "#666" }}>
                {" "}
                -{" "}
              </Typography>
              <Typography variant="p" style={{ color: "#666" }}>
                Rs. {priceRange[1]}
              </Typography>
              <Slider
                value={priceRange}
                onChange={handleChangePriceRange}
                valueLabelDisplay="auto"
                aria-labelledby="range-slider"
                getAriaValueText={valuetext}
                valueLabelFormat={numFormatter}
                min={minPrice}
                max={maxPrice}
                style={{ marginLeft: 2 }}
              />
            </div>
          </div>
          {/* On sale Box */}
          <div className={classes.onSaleBox}>
            <Typography variant="h5" style={{ paddingBottom: 10 }}>
              Sale
            </Typography>
            <FormControlLabel
              control={
                <Switch
                  checked={onSale.checkedB}
                  onChange={handleChangeOnSale}
                  name="checkedB"
                  color="primary"
                />
              }
              style={{ color: "#666" }}
              label="On Sale"
            />
          </div>
          {/* For Date Filters */}
          <div className={classes.dateRangeBox}>
            <Typography variant="h5" style={{ paddingBottom: 8 }}>
              Date
            </Typography>
            <form className={classes.containerDate} noValidate>
              <TextField
                id="startDate"
                label="Start Date"
                type="date"
                defaultValue={selectedFirstDate}
                onChange={handleFirstDateChange}
                className={classes.textFieldDate}
                InputLabelProps={{
                  shrink: true,
                }}
                style={{ marginBottom: 14 }}
              />
              <TextField
                id="endDate"
                label="End Date"
                type="date"
                defaultValue={selectedSecondDate}
                onChange={handleSecondDateChange}
                className={classes.textFieldDate}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </form>
          </div>
          {/* For Vendor/Brand Selection */}
          <div className={classes.BrandSelectBox}>
            <Typography variant="h5" style={{ paddingBottom: 3 }}>
              Brands
            </Typography>
            <ul className="toppings-list" className={classes.brandsList}>
              {brands.map((brand, index) => {
                return (
                  <li
                    style={{ listStyleType: "none", display: "flex" }}
                    key={index}
                  >
                    <div className="toppings-list-item">
                      <div className={classes.listItem}>
                        <input
                          type="checkbox"
                          id={`custom-checkbox-brand-${index}`}
                          name="brandCheckBox"
                          value={brand.vendorName}
                        />
                        <label
                          htmlFor={`custom-checkbox-brand-${index}`}
                          style={{ marginLeft: 9 }}
                        >
                          {brand.vendorName}
                        </label>
                      </div>
                      {/* <div className="right-section">
                            {getFormattedPrice(price)}
                          </div> */}
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
          {/* For Categories Filter Selection */}
          <div className={classes.BrandSelectBox}>
            <Typography variant="h5" style={{ paddingBottom: 3 }}>
              Related Categories
            </Typography>
            <ul className={classes.brandsList}>
              {subCategoriesOfMainCategory.map((category, index) => {
                return (
                  <li
                    style={{ listStyleType: "none", display: "flex" }}
                    key={index}
                  >
                    <div>
                      <div className={classes.listItem}>
                        <input
                          type="checkbox"
                          id={`custom-checkbox-${index}`}
                          name="categoryCheckBox"
                          value={category.name}
                        />
                        <label
                          htmlFor={`custom-checkbox-${index}`}
                          style={{ marginLeft: 9 }}
                        >
                          {category.name}
                        </label>
                      </div>
                      {/* <div className="right-section">
                            {getFormattedPrice(price)}
                          </div> */}
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
          <div id="filterError" style={{ color: "red" }}>
            {filterError}
          </div>
          <Button
            className={classes.applyFiltersBtn}
            style={{ fontWeight: "bold" }}
            onClick={handleApplyFilters}
          >
            <CheckCircleOutlineIcon
              style={{ paddingRight: 2, marginRight: 5 }}
            />
            Apply Filters
          </Button>
          <Button
            className={classes.ClearFiltersBtn}
            style={{ fontWeight: "bold" }}
            onClick={removeAllFilters}
          >
            <HighlightOffIcon style={{ paddingRight: 2, marginRight: 5 }} />
            Remove All
          </Button>
        </div>
      </div>
    );
  };

  return (
    <div style={{ backgroundColor: "#fff" }}>
      <div className={classes.mainAboutusContainer}>
        <Breadcrumbs
          style={{ paddingTop: 30, paddingBottom: 15 }}
          aria-label="breadcrumb"
        >
          <Link className={classes.bCrumbLink} color="inherit" to="/">
            Home
          </Link>
          {/* if main category products then show main category else get main category from first product */}
          {mainCategoryName ? (
            <Typography color="textPrimary">
              {mainCategoryName === "All Categories"
                ? searchQuery
                  ? `All Products Matching "${searchQuery}"`
                  : allProductsFilter
                  ? "Exciting Deals"
                  : "All Products"
                : mainCategoryName}
            </Typography>
          ) : mainCategoryOfSubCategory ? (
            <Link
              className={classes.bCrumbLink}
              color="inherit"
              to={`/products?mainCategoryName=${encodeURIComponent(
                mainCategoryOfSubCategory
              )}`}
            >
              {mainCategoryOfSubCategory}
            </Link>
          ) : null}

          {subCategoryName ? (
            <Typography color="textPrimary" noWrap>{subCategoryName}</Typography>
          ) : null}
        </Breadcrumbs>

        {/* Main Grid containing all items */}
        <Grid container>
          {/* Filters Grid */}
          <Grid lg={2} md={3} sm={3} className={classes.FiltersGrid}>
            {/* Categories Filters */}
            <div className={classes.categoriesFilters}>
              <div className={classes.categoriesFilterHeading}>
                <Typography variant="h5" style={{ padding: 13 }}>
                  Categories
                </Typography>
              </div>
              {/* Categories */}
              <div className={classes.categoreisFilters}>
                <List
                  component="nav"
                  aria-labelledby="nested-list-subheader"
                  className={classes.categoriesList}
                >
                  {categories.map((item) =>
                    React.cloneElement(
                      <div>
                        <ListItem
                          button
                          style={{ color: "#666" }}
                          onClick={() => handleClickListOpen(item._id)}
                        >
                          <ListItemText>{item.mainCategoryName}</ListItemText>
                          {isListOpen[item._id] ? (
                            <ExpandLess />
                          ) : (
                            <ExpandMore />
                          )}
                        </ListItem>
                        <Collapse
                          in={isListOpen[item._id]}
                          timeout="auto"
                          style={{ color: "#666" }}
                          unmountOnExit
                        >
                          {item.subCategories.map((subCategory) =>
                            React.cloneElement(
                              <List
                                component="div"
                                key={subCategory._id}
                                disablePadding
                              >
                                <ListItem
                                  onClick={() =>
                                    openProductsOfSubCategory(
                                      subCategory,
                                      item.mainCategoryName
                                    )
                                  }
                                  button
                                  className={classes.nested}
                                >
                                  <ListItemText primary={subCategory.name} />
                                </ListItem>
                              </List>,
                              { key: subCategory._id }
                            )
                          )}
                        </Collapse>
                      </div>,
                      {
                        key: item._id,
                      }
                    )
                  )}
                </List>
              </div>
            </div>

            {/* Price, categories, brand, on sale, date filters */}
            {filtersBox()}
          </Grid>
          {/* Products Grid */}
          <Grid lg={10} md={9} sm={8} className={classes.mainProductsGrid}>
            <div className={classes.ProductsHeadingBox}>
              <Typography variant="h4">
                {mainCategoryName
                  ? mainCategoryName === "All Categories"
                    ? searchQuery
                      ? `All Products Matching "${searchQuery}"`
                      : allProductsFilter
                      ? "Exciting Deals"
                      : "All Products"
                    : mainCategoryName
                  : subCategoryName}
              </Typography>
              {/* Sorting And results text box */}
              <div className={classes.resultsAndSortBox}>
                <Typography variant="p">
                  {productsData.length > 0
                    ? productsData.length === 1
                      ? "1 product found successfully."
                      : `Showing 1 - ${
                          productsData.length
                          // productsData.length > 16 ? 16 : productsData.length
                        } of ${productsData.length} products.`
                    : isLoading
                    ? `Fetching Products ...`
                    : `No products found matching  "${
                        searchQuery
                          ? searchQuery
                          : mainCategoryName
                          ? mainCategoryName
                          : subCategoryName
                      }" .`}
                </Typography>
                <div style={{ display: "flex", alignItems: "center" }}>
                <Button
                    style={{
                      display: "flex",
                      alignItems: "center",
                      textTransform: "none",
                      padding:7.2,marginRight:8
                    }}
                    onClick={()=>handleOpenFiltersModal()}
                    className={classes.FiltersMobileBtn}
                    variant="outlined"
                    // color="primary"
                  >
                   
                    <Tune color="primary" style={{ marginRight: 5 }} />
                    <Typography variant="h6" style={{marginLeft:0, color:"black"}}>
                    Filter
                    </Typography>
                  </Button>

                  <Typography
                    variant="p"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                    className={classes.sortByText}
                  >
                    Sort By:
                  </Typography>
                  <FormControl className={classes.formSorting}>
                    {/* <InputLabel htmlFor="demo-customized-select-native">
                    Sort By
                  </InputLabel> */}
                    <Select
                      native
                      label="Sort"
                      id="demo-customized-select-native"
                      value={selectedSort}
                      label
                      onChange={handleChangeSorting}
                      input={<BootstrapInput />}
                    >
                      {/* <option aria-label="None" value="Best Match" /> */}
                      {sort.map((item, index) => {
                        return (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        );
                      })}
                    </Select>
                  </FormControl>

                  
                </div>
              </div>
            </div>

            {/* All Products Box */}
            <Grid
              container
              className={classes.productsMainGrid}
              style={{
                justifyContent: isLoading ? "center" : "center",
                marginTop: isLoading ? "17%" : 0,
              }}
            >
              {productsData.length > 0 ? (
                productsData.map((item) =>
                  React.cloneElement(
                    <ProductCard
                      image={
                        Array.isArray(item.images)
                          ? item.images.length > 0
                            ? item.images[0]
                            : noImage
                          : item.images
                          ? item.images
                          : noImage
                      }
                      title={item.name}
                      cutPrice={item.discountPrice ? item.salePrice : null}
                      price={
                        item.discountPrice ? item.discountPrice : item.salePrice
                      }
                      category={item.category}
                      isNew={item.state === "new" ? true : false}
                      rating={item.avgRating}
                      discountPercentage={
                        item.discountPercentage ? item.discountPercentage : ""
                      }
                      _id={item._id}
                      storeName={item.storeName}
                      totalRatingStars={item.totalRatingStars}
                      brand={item.vendorCompanyName}
                      shippingCost={item.shippingCost}
                      stockAvailable={item.stockAvailable}
                      _id={item._id}
                    />,
                    {
                      key: item._id,
                    }
                  )
                )
              ) : (
                <div>
                  {productsData.length === 0 ? null : (
                    <img src={loadingImg}></img>
                  )}
                </div>
              )}
            </Grid>
          </Grid>
        </Grid>
      </div>
      <Modal
        open={openFiltersModal}
        hideBackdrop={true}
        onClose={handleCloseFiltersModal}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        className={classes.modalStyle1}
      >
        <div className={classes.modalMainBox}>
        <Button onClick={handleCloseFiltersModal} color="primary" variant="contained"><Close />Close</Button>
        {filtersBox()}
        </div>
      </Modal>
    </div>
  );
}
